export const TEST_ID = 'airspaceCard';

export const LAANC_GRID_LAYER = 'laanc_grid';

// Matches a trailing 3–5 letter uppercase airport code in parentheses at the end of a name,
// e.g. "Cedar Park Intl (CDP)" → ["Cedar Park Intl", "CDP"].
export const AIRPORT_CODE_PATTERN = /^(.+?)\s*\(([A-Z]{3,5})\)\s*$/;

export const LAANC_SUBTITLE_TEXT = 'LAANC enabled airport';

export const LAANC_BODY_TEXT = 'Further coordination required. Request through LAANC.';

export const CEILING_UNKNOWN_TEXT = 'Ceiling unknown — coordinate via LAANC';

export const CEILING_ZERO_TEXT = 'Further Coordination required';
